import { CreateDomainInput, Domain } from '../models/domain.model';

export abstract class DomainsRepository {
  abstract getDomains(): Promise<Domain[]>;
  abstract createDomain(input: CreateDomainInput): Promise<Domain>;
  abstract updateDomain(id: number, input: CreateDomainInput): Promise<Domain>;
  abstract setDomainArchived(id: number, archived: boolean): Promise<void>;
  abstract setShortcutVisible(id: number, visible: boolean): Promise<void>;
  abstract deleteDomain(id: number): Promise<void>;
}
